/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import { useTheme } from '@mui/material';
import { useMemo } from 'react';
import { ToastContainer } from 'react-toastify';
import { alertToastContainerProps, notificationToastContainerProps } from './toastContainers';
import { getToastThemeVars } from './toastTheme';

/** Alert toasts (bottom left) and notification toasts (top right), in the active theme. */
export const AppToastContainers = () => {
  const theme = useTheme();
  const toastThemeVars = useMemo(() => getToastThemeVars(theme), [theme]);
  const { mode } = theme.palette;
  return (
    <div className="theme" style={toastThemeVars}>
      <ToastContainer {...alertToastContainerProps} theme={mode} />
      <ToastContainer {...notificationToastContainerProps} theme={mode} />
    </div>
  );
};
